import { COMBO_TYPES, EDGE_TYPES, NODE_TYPES } from './constants';
import { comboConfig } from './combos';
import { edgeConfig } from './edges';
import {
  abSplitConfig,
  addContactConfig,
  attributeSplitConfig,
  baseNodeConfig,
  baseWitNestedNodesConfig,
  baseWithFooterNodeConfig,
  callWebhookConfig,
  changeContactFieldConfig,
  channelOptConfig,
  contactActionBaseConfig,
  delayBaseConfig,
  delayNodeConfig,
  fbAudienceConfig,
  fieldsMatchConfig,
  holdNodeConfig,
  holdUntilReplyNodeConfig,
  miscBaseConfig,
  modifyChannelConfig,
  modifyFlowBaseConfig,
  modifyMessageTypeConfig,
  noteNodeConfig,
  removeContactConfig,
  sendActionBaseConfig,
  sendEmailConfig,
  sendEmbeddedConfig,
  sendInAppConfig,
  sendPushConfig,
  sendSMSConfig,
  sendWebPushConfig,
  sendWhatsAppConfig,
  startNodeConfig,
  tilesetConfig,
  triggerWorkflowConfig,
} from './nodes';

export * from './constants';
export * from './combos';
export * from './edges';
export * from './nodes';
export * from './utils';

export const edgeTypeConfigs = {
  [EDGE_TYPES.DEFAULT]: {
    name: EDGE_TYPES.DEFAULT,
    config: edgeConfig,
    extend: 'cubic-vertical',
  },
};

export const comboTypeConfigs = {
  [COMBO_TYPES.DEFAULT]: {
    name: COMBO_TYPES.DEFAULT,
    config: comboConfig,
    extend: 'rect',
  },
};

export const nodeTypeConfigs = {
  [NODE_TYPES.BASE]: {
    name: NODE_TYPES.BASE,
    config: baseNodeConfig,
    extend: 'single-node',
  },
  [NODE_TYPES.BASE_WITH_FOOTER]: {
    name: NODE_TYPES.BASE_WITH_FOOTER,
    config: baseWithFooterNodeConfig,
    extend: NODE_TYPES.BASE,
  },
  [NODE_TYPES.BASE_WITH_NESTED_NODES]: {
    name: NODE_TYPES.BASE_WITH_NESTED_NODES,
    config: baseWitNestedNodesConfig,
    extend: NODE_TYPES.BASE_WITH_FOOTER,
  },
  [NODE_TYPES.START]: {
    name: NODE_TYPES.START,
    config: startNodeConfig,
    extend: NODE_TYPES.BASE,
  },
  // Delay
  [NODE_TYPES.DELAY_BASE]: {
    name: NODE_TYPES.DELAY_BASE,
    config: delayBaseConfig,
    extend: NODE_TYPES.BASE,
  },
  [NODE_TYPES.DELAY]: {
    name: NODE_TYPES.DELAY,
    config: delayNodeConfig,
    extend: NODE_TYPES.DELAY_BASE,
  },
  [NODE_TYPES.HOLD]: {
    name: NODE_TYPES.HOLD,
    config: holdNodeConfig,
    extend: NODE_TYPES.DELAY_BASE,
  },
  [NODE_TYPES.HOLD_UNTIL_REPLY]: {
    name: NODE_TYPES.HOLD_UNTIL_REPLY,
    config: holdUntilReplyNodeConfig,
    extend: NODE_TYPES.DELAY_BASE,
  },
  // Modify Flow
  [NODE_TYPES.MODIFYFLOW_BASE]: {
    name: NODE_TYPES.MODIFYFLOW_BASE,
    config: modifyFlowBaseConfig,
    extend: NODE_TYPES.BASE,
  },
  [NODE_TYPES.FIELDS_MATCH]: {
    name: NODE_TYPES.FIELDS_MATCH,
    config: fieldsMatchConfig,
    extend: NODE_TYPES.MODIFYFLOW_BASE,
  },
  [NODE_TYPES.AB_SPLIT]: {
    name: NODE_TYPES.AB_SPLIT,
    config: abSplitConfig,
    extend: NODE_TYPES.MODIFYFLOW_BASE,
  },
  [NODE_TYPES.ATTRIBUTE_SPLIT]: {
    name: NODE_TYPES.ATTRIBUTE_SPLIT,
    config: attributeSplitConfig,
    extend: NODE_TYPES.MODIFYFLOW_BASE,
  },
  [NODE_TYPES.TRIGGER_WORKFLOW]: {
    name: NODE_TYPES.TRIGGER_WORKFLOW,
    config: triggerWorkflowConfig,
    extend: NODE_TYPES.MODIFYFLOW_BASE,
  },
  // Send actions
  [NODE_TYPES.SEND_ACTION_BASE]: {
    name: NODE_TYPES.SEND_ACTION_BASE,
    config: sendActionBaseConfig,
    extend: NODE_TYPES.BASE_WITH_FOOTER,
  },
  [NODE_TYPES.SEND_EMAIL]: {
    name: NODE_TYPES.SEND_EMAIL,
    config: sendEmailConfig,
    extend: NODE_TYPES.SEND_ACTION_BASE,
  },
  [NODE_TYPES.SEND_PUSH]: {
    name: NODE_TYPES.SEND_PUSH,
    config: sendPushConfig,
    extend: NODE_TYPES.SEND_ACTION_BASE,
  },
  [NODE_TYPES.SEND_WEB_PUSH]: {
    name: NODE_TYPES.SEND_WEB_PUSH,
    config: sendWebPushConfig,
    extend: NODE_TYPES.SEND_ACTION_BASE,
  },
  [NODE_TYPES.SEND_WHATSAPP]: {
    name: NODE_TYPES.SEND_WHATSAPP,
    config: sendWhatsAppConfig,
    extend: NODE_TYPES.SEND_ACTION_BASE,
  },
  [NODE_TYPES.SEND_SMS]: {
    name: NODE_TYPES.SEND_SMS,
    config: sendSMSConfig,
    extend: NODE_TYPES.SEND_ACTION_BASE,
  },
  [NODE_TYPES.SEND_EMBEDDED]: {
    name: NODE_TYPES.SEND_EMBEDDED,
    config: sendEmbeddedConfig,
    extend: NODE_TYPES.SEND_ACTION_BASE,
  },
  [NODE_TYPES.SEND_IN_APP]: {
    name: NODE_TYPES.SEND_IN_APP,
    config: sendInAppConfig,
    extend: NODE_TYPES.SEND_ACTION_BASE,
  },
  [NODE_TYPES.CHANNEL_OPT]: {
    name: NODE_TYPES.CHANNEL_OPT,
    config: channelOptConfig,
    extend: NODE_TYPES.BASE_WITH_NESTED_NODES,
  },
  // User actions
  [NODE_TYPES.CONTACT_ACTION_BASE]: {
    name: NODE_TYPES.CONTACT_ACTION_BASE,
    config: contactActionBaseConfig,
    extend: NODE_TYPES.BASE,
  },
  [NODE_TYPES.ADD_CONTACT]: {
    name: NODE_TYPES.ADD_CONTACT,
    config: addContactConfig,
    extend: NODE_TYPES.CONTACT_ACTION_BASE,
  },
  [NODE_TYPES.REMOVE_CONTACT]: {
    name: NODE_TYPES.REMOVE_CONTACT,
    config: removeContactConfig,
    extend: NODE_TYPES.CONTACT_ACTION_BASE,
  },
  [NODE_TYPES.CHANGE_CONTACT_FIELD]: {
    name: NODE_TYPES.CHANGE_CONTACT_FIELD,
    config: changeContactFieldConfig,
    extend: NODE_TYPES.CONTACT_ACTION_BASE,
  },
  [NODE_TYPES.UPDATE_CONTACT_WEBHOOK]: {
    name: NODE_TYPES.UPDATE_CONTACT_WEBHOOK,
    config: changeContactFieldConfig,
    extend: NODE_TYPES.CONTACT_ACTION_BASE,
  },
  [NODE_TYPES.MODIFY_CHANNEL_SUBSCRIPTION]: {
    name: NODE_TYPES.MODIFY_CHANNEL_SUBSCRIPTION,
    config: modifyChannelConfig,
    extend: NODE_TYPES.CONTACT_ACTION_BASE,
  },
  [NODE_TYPES.MODIFY_MESSAGE_TYPE]: {
    name: NODE_TYPES.MODIFY_MESSAGE_TYPE,
    config: modifyMessageTypeConfig,
    extend: NODE_TYPES.CONTACT_ACTION_BASE,
  },
  [NODE_TYPES.ADD_USER_TO_FB]: {
    name: NODE_TYPES.ADD_USER_TO_FB,
    config: fbAudienceConfig,
    extend: NODE_TYPES.MISC_BASE,
  },
  [NODE_TYPES.REMOVE_USER_FROM_FB]: {
    name: NODE_TYPES.REMOVE_USER_FROM_FB,
    config: fbAudienceConfig,
    extend: NODE_TYPES.MISC_BASE,
  },
  // Misc
  [NODE_TYPES.MISC_BASE]: {
    name: NODE_TYPES.MISC_BASE,
    config: miscBaseConfig,
    extend: NODE_TYPES.BASE,
  },
  [NODE_TYPES.CALL_WEBHOOK]: {
    name: NODE_TYPES.CALL_WEBHOOK,
    config: callWebhookConfig,
    extend: NODE_TYPES.MISC_BASE,
  },
  // Annotations
  [NODE_TYPES.NOTE]: {
    name: NODE_TYPES.NOTE,
    config: noteNodeConfig,
    extend: 'modelRect',
  },
  [NODE_TYPES.TILESET]: {
    name: NODE_TYPES.TILESET,
    config: tilesetConfig,
    extend: 'circle',
  },
};
